import { Avatar } from "@mui/material";
import useTheme from "@mui/material/styles/useTheme";
import { t } from "i18next";
import { Link } from "../../../components";
import { NAVBAR_ITEMS } from "../../../consts";
import { useGetProfileImageQuery } from "../../../queries";
import { useAuthStore, useNavbarStore } from "../../../stores";
import { stringAvatar, getUserAvatar } from "../../../utils/avatar";

export function ProfileIcon() {
  const theme = useTheme();
  const userData = useAuthStore(state => state.userData);

  const setNavbarItem = useNavbarStore(state => state.setNavbarItem);

  const { data: profileImage  } = useGetProfileImageQuery({});

  const userAvatar = getUserAvatar(profileImage, userData);

  return (
    <Link
      sx={ {
        "&:focus": {
          outline: "none"
        },
        "&:focus-visible": {
          outline: `2px solid ${theme.customColors.headerIcon}`,
          outlineOffset: "2px" }
      } }
      aria-label={ `${t("go_profile")} - ${userData?.name} ${userData?.surname}` }
      href="/profile"
      onClick={ ()=> { setNavbarItem(NAVBAR_ITEMS.NONE) } }
      zIndex={ theme.zIndex.fab }
    >
      <Avatar
        alt=""
        aria-hidden={ true }
        { ...stringAvatar(userAvatar.initials) }
        src={ userAvatar.src }
        sx={ {
          color: theme.customColors?.backgroundPrimaryLighterAlternative,
          height:"2.5rem",
          width:"2.5rem"
        } }
      />
    </Link>
  );

}
